<template>
  <div class="select-data-range">
     <van-nav-bar
      title="公司组织选择"
      @click-left="onClickLeft"
    >
      <template #left>
        <van-icon name="arrow-left" size="0.533rem" color="#333333"/>
      </template>
    </van-nav-bar>
    <ul class="selected-data-area">
      <li v-for="(item, index) in selectedData" :key="item.id" class="selected-item">
         <i 
          v-if="index !== 0"
          class="iconfont icon-xiangxiajiantou arrow-right" 
        ></i>
        <span :style="{color: index === selectedData.length -1 ? '#1584ff' : '#999999'}">{{ item.name }}</span>
      </li>
    </ul>
    <div class="tree-wrapper">
      <ul class="tree-list" >
        <li v-for="(nodeF) in data" :key="nodeF.id"  :style="{paddingLeft: '18px'}">
            <div class="label-wrapper" >
              <div class="label-area">
                <div 
                  class="check-block" 
                  :style='{"borderColor": nodeF.isSelected ? "#1584ff" : "rgba(0, 0, 0, 0.15)"}' 
                  @click="handleCheck(nodeF)"
                >
                  <span v-if="nodeF.isSelected" class="check-radio"></span>
                </div>
                
              </div>
              <div class="label-click"  @click="handleisExpanded(nodeF)">
                <label>{{ nodeF.name }}</label>
                <i 
                  class="iconfont icon-xiangxiajiantou rotate" 
                  v-if="nodeF.childList" 
                  :class="{ 'has-expend': !nodeF.isExpanded }"
                ></i>
              </div>
            </div>
            <transition
              @enter="enter"
              @afterEnter="afterEnter"
              @leave="leave"
              @afterLeave="afterLeave"
            >
              <ul class="tree-list" v-if="nodeF.isExpanded">
                <li v-for="nodeS in nodeF.childList" :key="nodeS.id"  :style="{paddingLeft: '18px'}">
                    <div class="label-wrapper" >
                      <div class="label-area">
                        <div 
                          class="check-block" 
                          :style='{"borderColor": nodeS.isSelected ? "#1584ff" : "rgba(0, 0, 0, 0.15)"}' 
                          @click="handleCheck(nodeS)"
                        >
                          <span v-if="nodeS.isSelected" class="check-radio"></span>
                        </div>
                        
                      </div>
                      <div class="label-click"  @click="handleisExpanded(nodeS)">
                        <label>{{ nodeS.name }}</label>
                        <i 
                          class="iconfont icon-xiangxiajiantou rotate" 
                          v-if="nodeS.childList" 
                          :class="{ 'has-expend': !nodeS.isExpanded }"
                        ></i>
                      </div>
                    </div>
                    <transition
                      @enter="enter"
                      @afterEnter="afterEnter"
                      @leave="leave"
                      @afterLeave="afterLeave"
                    >
                      <ul class="tree-list" v-if="nodeS.isExpanded">
                        <li v-for="nodeT in nodeS.childList" :key="nodeT.id"  :style="{paddingLeft: '18px'}">
                          <template v-if="nodeT.type < 3">
                            <div class="label-wrapper" >
                              <div class="label-area">
                                <div 
                                  class="check-block" 
                                  :style='{"borderColor": nodeT.isSelected ? "#1584ff" : "rgba(0, 0, 0, 0.15)"}' 
                                  @click="handleCheck(nodeT)"
                                >
                                  <span v-if="nodeT.isSelected" class="check-radio"></span>
                                </div>
                                
                              </div>
                              <div class="label-click"  @click="handleisExpanded(nodeT)">
                                <label>{{ nodeT.name }}</label>
                                <!-- <i 
                                  class="iconfont icon-xiangxiajiantou" 
                                  v-if="nodeT.children && nodeT.level < 2" 
                                  :class="{ 'has-expend': !nodeT.isExpanded }"
                                ></i> -->
                              </div>
                            </div>
                          </template>
                        </li>
                      </ul>
                    </transition>
                </li>
                  
              </ul>
            </transition>
        </li>
      </ul>
      <div class="empty" v-if="isEmpty">
        <span class="empty-text">暂无数据</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompanySystem } from "@/axios/services"
import { Toast } from "vant"
export default {
  name: "selectDataRange",
  data () {
    return {
      data: [],
      flatTree: [],
      selectedData: []
    }
  },
  created () {
    this.queryCompanySystem()
  },
  methods: {
    onClickLeft () {
      this.$route.params.selectedData = this.selectedData;
      this.$router.back()
    },
    async queryCompanySystem () {
      let [error, data] = await this.to(getCompanySystem({
        companyId: localStorage.getItem("companyId") === "undefined" ? 
                  "cfe05dd2cedf4dd1ad9475d32838eaf9" : 
                  localStorage.getItem("companyId"),
      }))
      if (error) {
        return Toast.fail(error)
      }
      if (data) {
        this.data = data
        this.flatTree = this.formatFlatData(this.data)
        this.initStatus()
      }
    },
    initStatus () {
      if (!this.selectedCompany.length) {
        this.formatData(this.data, true, true)
        this.selectedData = this.data
      } else {
        let curNode = this.selectedCompany[this.selectedCompany.length -1]
        let treeNode = this.flatTree.find(el => el.id === curNode?.id && el.level === curNode.level)
        if (treeNode) {
          this.setParentNode(treeNode)
          this.handleCheck(treeNode)
        }
      }
    },
    handleisExpanded (node) {
      this.$set(node, 'isExpanded', !node.isExpanded)
      this.$forceUpdate()
    },
    setParentNode (treeNode) {
      let parentNode = this.flatTree.find(el => el.id === treeNode?.parentId)
      if (parentNode) {
        this.$set(parentNode, 'isExpanded', !parentNode.isExpanded)
        if (parentNode.parentId) {
          this.setParentNode(parentNode)
        }
      }
    },
    handleCheck (curNode) {
      this.clearSelected(this.data, curNode)
      this.$set(curNode, 'isSelected', !curNode.isSelected)
      this.selectChildrenNode(curNode.childList || [], curNode.isSelected)
      this.selectedData = this.getSelectedData(curNode)
      this.$forceUpdate()
    }, 
    getSelectedData (curNode) {
      const _self = this
      let res = []
      res.push(curNode)
      function findeParent (curNode) {
        let node = _self.flatTree.find((el) => {
           return el.id === curNode.parentId &&  curNode.level - el.level === 1
        })
        if (node) {
          res.push(node)
          findeParent(node)
        }
      }
      findeParent(curNode)
      res.sort((a, b) => {
        return a.level - b.level
      })
      return res
    },
    selectChildrenNode (nodes, choice) {
      nodes.forEach((node) => { 
        this.$set(node, 'isSelected', choice)
        this.$forceUpdate()
        this.selectChildrenNode(node.childList || [], choice) 
      })
    },
    clearSelected (data, curNode) {
      data.forEach(el => {
        el.isSelected = false
        if (el.childList && Array.isArray(el.childList)) {
          return this.clearSelected(el.childList, curNode)
        }
      });
    },
    formatFlatData (data) {
      var flatTree = [];
      function flattenChildren(node) {
          node.forEach(function (child) {
            flatTree.push(child);
            if (child.childList) {
              return flattenChildren(child.childList);
            }
          });
      }
      flattenChildren(data);
      return flatTree;
    },
    formatData (data, isExpanded, isSelected) {
      data.forEach(el => {
        el.isExpanded = isExpanded ?? false
        el.isSelected = isSelected ?? false
        if (el.childList && Array.isArray(el.childList)) {
          return this.formatData(el.childList, isExpanded, isSelected)
        }
      });
    },
    enter (el) {
      el.classList.add('collapse')
      el.style.height = 'auto'
      let endWidth = window.getComputedStyle(el).height
      el.style.height = '0px'
      el.offsetHeight // force repaint
      el.style.height = endWidth
    },
    afterEnter (el) {
      el.classList.remove('collapse')
      el.style.height = null
    },
    leave (el) {
      el.classList.add('collapse')
      el.style.height = window.getComputedStyle(el).height
      el.offsetHeight // force repaint
      el.style.height = '0px'
    },
    afterLeave (el) {
      el.classList.remove('collapse')
      el.style.height = null
    },
    to (promise, errorFirst = true) {
      return promise.then(data => {
        let { code, msg, data: res } = data.data
        if (code == 0) {
          return errorFirst ? [null, res] : [null, res]
        } else {
          Toast.fail(msg)
          return errorFirst ? [null, null] : [null, null]
        }
      }).catch(err => {
        return errorFirst ? [err, null] : [null, err]
      }) 
    }
  },
  computed: {
    isEmpty () {
      return !this.data.length
    },
    selectedCompany () {
      let res = ""
      try {
        res = JSON.parse(this.$route.query.seletionData)
      } catch (err) {
        console.log(err)
      }
      return res
    }
  },
  // watch: {
  //   data: {
  //     handler () {
  //       console.log(111)
  //       this.$forceUpdate()
  //     },
  //     deep: true
  //   }
  // }
  
}
</script>


<style scoped>
* {
  padding: 0;
  margin: 0;
}
.has-expend {
  transform: rotateZ(-90deg) !important;
}
.arrow-right {
  transform: rotateZ(-90deg) !important;
  margin-right: 10px;
}

.collapse {
  transition: height .3s ease-in-out;
  overflow: hidden;
}

 .label-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
 }
 .tree-item {
  padding: 10px 0;
 }

 .label-wrapper {
   padding: 10px 0;
 }

 .label-wrapper span{
    padding-left: 20px;
    color:#000000;
    font-size:14px;
 }
 .label-area {
    display: flex;
    align-items: center;
 }

 .rotate {
    margin-right: 20px;
    font-size: 20px;
    transition: all .3s ease;
 }
 .check-block {
    width:16px;
    height:16px;
    border:1px solid;
    border-radius:8px; 
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
 }

.check-radio {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color:#1584ff;
  border-radius:8px;
  padding: 0 !important;
}

.label-click {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.empty {
  display: flex;
  justify-content: center;
  align-items: center
}
.empty-text {
  font-size: 16px
}
.tree-wrapper {
  background-color: #fff;
}

.selected-data-area {
  padding: 10px 0 10px 20px;
}

.selected-item {
  line-height: 25px;
  font-size: 14px;
}
</style>